export class PasswordOptions {
    requiredLength: number;
    requiredUniqueChars: number; // в текущей версии не используется, зарезервировано
    requireNonAlphanumeric: boolean;
    requireLowercase: boolean;
    requireUppercase: boolean;
    requireDigit: boolean;
}
